// extracted by mini-css-extract-plugin
export default {"wrapper":"customers_wrapper__qnOlO","selectButttons":"customers_selectButttons__8Mbct","clientsList":"customers_clientsList__l+XKA","clientItem":"customers_clientItem__E-2bc"};